import {
  Star,
  LayoutDashboard, Package, ShoppingBag, Users, Ticket, Settings, BarChart3,
  ImageIcon, Truck, Tag, Megaphone, Palette, Globe, CreditCard, UserCog,
  BookOpen,
  Building2,
} from "lucide-react";

// Keys yang WAJIB selalu aktif untuk semua paket (backend juga memaksa enabled).
export const ALWAYS_ON_KEYS = ["core.settings", "core.subscription"];

// Single source of truth: mapping menu dashboard tenant admin ↔ feature key
// ↔ permission (Multi Admin v1). Backend tetap source of truth enforcement.
export const ADMIN_NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", exact: true, featureKey: "core.dashboard", permission: "dashboard.view" },
  { to: "/admin/produk", icon: Package, label: "Produk", featureKey: "core.products", permission: "products.view" },
  { to: "/admin/kategori", icon: Tag, label: "Kategori", featureKey: "core.categories", permission: "categories.manage" },
  {
    to: "/admin/pesanan", icon: ShoppingBag, label: "Pesanan", featureKey: "core.orders", permission: "orders.view",
    badge: "new_orders", badgeLabel: "pesanan baru belum dilihat",
    // Phase 3: submenu operasional (badge anak independen; badge induk HANYA pesanan baru)
    children: [
      { to: "/admin/pesanan", label: "Semua Pesanan", exact: true },
      { to: "/admin/pesanan/pembatalan", label: "Pembatalan", badge: "cancellation_requests", badgeLabel: "permintaan pembatalan menunggu" },
      { to: "/admin/pesanan/refund", label: "Refund", badge: "refund_pending", badgeLabel: "refund menunggu diproses" },
    ],
  },
  { to: "/admin/pelanggan", icon: Users, label: "Pelanggan", featureKey: "core.customers", permission: "customers.view" },
  { to: "/admin/promo", icon: Ticket, label: "Promo & Voucher", featureKey: "marketing.voucher", permission: "banners.manage" },
  { to: "/admin/banner", icon: ImageIcon, label: "Banner", featureKey: "marketing.banner", permission: "banners.manage" },
  { to: "/admin/ulasan", icon: Star, label: "Ulasan Produk", featureKey: "reviews.product", permission: "products.manage" },
  { to: "/admin/popup", icon: Megaphone, label: "Popup Banner", featureKey: "marketing.popup_banner", permission: "banners.manage" },
  { to: "/admin/laporan", icon: BarChart3, label: "Laporan", featureKey: "reports.basic", permission: "reports.basic" },
  { to: "/admin/jubelio", icon: Truck, label: "Jubelio Shipment", featureKey: "integration.jubelio", permission: "shipping.manage" },
  { to: "/admin/biteship", icon: Truck, label: "Biteship Shipping", featureKey: "integration.biteship", permission: "shipping.manage" },
  { to: "/admin/shipping", icon: Truck, label: "Shipping Settings", featureKey: "shipping.settings", permission: "shipping.manage" },
  { to: "/admin/branding", icon: Palette, label: "Platform Branding", featureKey: "branding.platform", permission: "branding.manage" },
  { to: "/admin/seo", icon: Globe, label: "Platform SEO", featureKey: "seo.platform", permission: "branding.manage" },
  { to: "/admin/company-profile", icon: Building2, label: "Profil Perusahaan", featureKey: "storefront.company_profile", permission: "branding.manage" },
  { to: "/admin/tim", icon: UserCog, label: "Tim & Akses", featureKey: "core.settings", permission: "team.view" },
  { to: "/admin/langganan", icon: CreditCard, label: "Langganan", featureKey: "core.subscription", permission: "subscription.manage" },
  { to: "/admin/pengaturan", icon: Settings, label: "Pengaturan", featureKey: "core.settings", permission: "settings.manage" },
  { to: "/admin/tutorials", icon: BookOpen, label: "Pusat Panduan", permission: "dashboard.view" },
];

// Cek permission user (owner/legacy tanpa permissions array = akses penuh).
export const hasPermission = (user, permission) => {
  if (!permission) return true;
  if (!user) return false;
  if (!Array.isArray(user.permissions)) return true; // legacy owner (belum re-login)
  return user.permissions.includes(permission);
};
